import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Sidebar from '../components/portal/Sidebar';
import QRList from '../components/portal/QRList';
import QRForm from '../components/portal/QRForm';
import PrintQR from '../components/portal/PrintQR';
import TemplateManager from '../components/portal/TemplateManager';
import TemplateGenerator from '../components/portal/TemplateGenerator';
import TemplateGeneratorPreview from '../components/portal/TemplateGeneratorPreview';
import UserSettings from '../components/portal/UserSettings';
import UserManager from '../components/portal/UserManager';
import TestimonialManager from "../components/portal/TestimonialManager";
import MenuManager from "../components/portal/MenuManager";



function Portal() {
    return (
        <div className="d-flex vh-100 bg-light">
            <Sidebar />
            <main className="flex-fill overflow-auto">
                <Routes>
                    <Route path="/" element={<Navigate to="/portal/qrs" replace />} />
                    <Route path="/qrs" element={<QRList />} />
                    <Route path="/qrs/new" element={<QRForm />} />
                    <Route path="/qrs/edit/:id" element={<QRForm />} />
                    <Route path="/template-manager" element={<TemplateManager />} />
                    <Route path="/template-generator" element={<TemplateGenerator />} />
                    <Route path="/template-generator-preview" element={<TemplateGeneratorPreview />} />
                    <Route path="/print/:id" element={<PrintQR />} />
                    <Route path="/user-settings" element={<UserSettings />} />
                    <Route path="/users" element={<UserManager />} />
                    <Route path="/testimonials" element={<TestimonialManager />} />
                    <Route path="/menus" element={<MenuManager />} />
                </Routes>
            </main>
        </div>
    );
};

export default Portal;